"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueFromText_1 = __importDefault(require("../serialize/valueFromText"));
const constants_1 = require("../constants");
function insertText(editorState, start, end, text) {
    const value = valueFromText_1.default(text);
    return editorState.change({
        isBoundary: editorState.lastChangeType !== constants_1.COMMAND.INSERT_CHARACTER,
        type: constants_1.COMMAND.INSERT_TEXT,
        start,
        end,
        value: value,
    }).change({
        type: constants_1.COMMAND.INSERT_TEXT,
        start: start + value.length,
        end: start + value.length,
        value: []
    });
}
exports.default = insertText;
//# sourceMappingURL=insertText.js.map